module.exports = ".message{font-size:20px;font-weight:bold}@media screen and (max-width: 960px){.message{font-size:12px}}\n"